"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const api_1 = require("primereact/api");
const toastContext_1 = require("./context/toast/toastContext");
const react_router_dom_1 = require("react-router-dom");
const InvoiceRoutes_1 = require("./routes/InvoiceRoutes");
const InvoiceApp = () => {
    return ((0, jsx_runtime_1.jsx)(api_1.PrimeReactProvider, { children: (0, jsx_runtime_1.jsx)(toastContext_1.ToastProvider, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.RouterProvider, { router: InvoiceRoutes_1.invoiceRouter }) }) }));
};
exports.default = InvoiceApp;
